module.exports = __webpack_public_path__ + "static/img/top03.80d030a7.svg";